export const UPDATE = {
    REQUEST: 'DELIVERY_NOTE.RETURN.UPDATE.REQUEST',
    SUCCESS: 'DELIVERY_NOTE.RETURN.UPDATE.SUCCESS',
    FAILED: 'DELIVERY_NOTE.RETURN.UPDATE.FAILED',
};

export const CLEAR_STATE = 'DELIVERY_NOTE.RETURN.ADD.CLEAR_STATE';

export const RESET_ERROR = 'DELIVERY_NOTE.RETURN.ADD.RESET_ERROR';
